import React from 'react'
import {
  AppstoreAddOutlined,
  GlobalOutlined,
  HddOutlined,
  RiseOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons'
import { superAdminRoutes } from 'shared/constants/routes'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { horsesSelectors } from 'store/horses'
import { reviewsSelectors } from 'store/reviews'
import { withdrawalRequestsSelectors } from 'store/withdrawalRequests'
import { supportSelectors } from 'store/support'
import { IMobileTab, MobileTabBar } from './MobileTabBar'

// Разделы верхнего меню, кроме «Настроек»: на телефоне ими не пользуются
const tabs: IMobileTab[] = [
  {
    key: superAdminRoutes.SELLERS,
    label: 'Продавцы',
    icon: <UsergroupAddOutlined />,
    children: [
      { key: superAdminRoutes.SELLERS, label: 'Продавцы' },
      { key: superAdminRoutes.USERS, label: 'Пользователи' },
      { key: superAdminRoutes.SUPPORT, label: 'Поддержка' }
    ]
  },
  {
    key: superAdminRoutes.ORDERS,
    label: 'Заказы',
    icon: <HddOutlined />
  },
  {
    key: superAdminRoutes.MAIN,
    label: 'Продвижение',
    icon: <RiseOutlined />,
    children: [
      { key: superAdminRoutes.MAIN, label: 'Продвижение' },
      { key: superAdminRoutes.PROMOCODES, label: 'Промокоды' },
      { key: superAdminRoutes.DISCOUNTS, label: 'Скидки' },
      { key: superAdminRoutes.POLO_CLUB, label: 'ПолоКлуб' }
    ]
  },
  {
    key: superAdminRoutes.GOODS,
    label: 'Товары',
    icon: <AppstoreAddOutlined />,
    children: [
      { key: superAdminRoutes.GOODS, label: 'Товары' },
      { key: superAdminRoutes.CATEGORIES, label: 'Категории' },
      { key: superAdminRoutes.HORSES, label: 'Лошади' }
    ]
  },
  {
    key: superAdminRoutes.ACTIONS,
    label: 'Действия',
    icon: <GlobalOutlined />
  }
]

export const SuperAdminTabBar: React.FC = () => {
  const pendingReviewsCount = useAppSelector(reviewsSelectors.selectPendingCount)
  const pendingWithdrawalRequestsCount = useAppSelector(
    withdrawalRequestsSelectors.selectPendingCount
  )
  const actionsCount = pendingReviewsCount + pendingWithdrawalRequestsCount
  const supportUnreadCount = useAppSelector(supportSelectors.selectTotalUnread)
  const moderationHorsesCount = useAppSelector(horsesSelectors.selectModerationCount)

  return (
    <MobileTabBar
      tabs={tabs.map((tab) => {
        if (tab.key === superAdminRoutes.ACTIONS) {
          return { ...tab, badgeCount: actionsCount }
        }
        if (tab.key === superAdminRoutes.GOODS) {
          return {
            ...tab,
            badgeCount: moderationHorsesCount,
            children: tab.children?.map((child) =>
              child.key === superAdminRoutes.HORSES
                ? { ...child, badgeCount: moderationHorsesCount }
                : child
            )
          }
        }
        if (tab.key === superAdminRoutes.SELLERS) {
          return { ...tab, badgeCount: supportUnreadCount }
        }
        return tab
      })}
    />
  )
}
